import { render, staticRenderFns } from "./Covid-19.vue?vue&type=template&id=58ff0c18&scoped=true&"
import script from "./Covid-19.vue?vue&type=script&lang=js&"
export * from "./Covid-19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff0c18",
  null
  
)

export default component.exports